export const environment = {
  production: false,
  appType: 'mitra',
  appTitle: 'Warung Pangan',
  authBaseUrl: '/api/v1/wp/mitra/auth/',
  saleshubPdfUrl: 'https://dev-saleshub.idfood.co.id/api/f_trans/c_subsidiary_inventory_sales_order/create_pdf_so',
  qrDomain: 'https://dev-warungpangan.idfood.co.id'
};
